package fr.frux.feature.treedetail.identity

import fr.frux.shared.domain.model.Species
import fr.frux.shared.domain.model.offeredForTrees

internal const val MIN_SPECIES_QUERY_LENGTH = 2

/**
 * Recherche de la feuille d'espèce : espèces sélectionnables seules, accents et casse ignorés,
 * rangées par nom commun. Sous deux caractères, aucun résultat.
 */
fun searchSpecies(
    referential: List<Species>,
    query: String,
    limit: Int = 8,
): List<Species> {
    val trimmed = query.trim()
    if (trimmed.length < MIN_SPECIES_QUERY_LENGTH) return emptyList()
    return referential
        .filter { it.offeredForTrees && it.matches(trimmed) }
        .sortedBy { it.commonNameFr.lowercase() }
        .take(limit)
}
